goog.provide("shadow.js.shim.module$src$svg$artwork$broken_link_svg$default");
shadow.js.shim.module$src$svg$artwork$broken_link_svg$default = shadow.js.shim.module$src$svg$artwork$broken_link_svg.default;
